module.exports = __webpack_public_path__ + "static/img/32.0270f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/32.png
// module id = e/Wg
// module chunks = 1